import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { ListInventoryItemSnapshotsResponse } from '../models/ListInventoryItemSnapshotsResponse';

/**
 * no description
 */
export class ListInventoryItemSnapshotsApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Get all snapshots for a specific inventory item
   * @param id ID of the inventory item
   * @param pageIndex The page index
   * @param pageSize The numbers of items per page
   * @param snapshotType snapshot types eon or gp
   * @param projectId The project ID
   * @param start The start date for the query
   * @param end The end date for the query
   */
  public async listInventoryItemSnapshots(id: string, pageIndex: number, pageSize: number, snapshotType: string, projectId: string, start?: Date, end?: Date, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'id' is not null or undefined
    if (id === null || id === undefined) {
      throw new RequiredError("ListInventoryItemSnapshotsApi", "listInventoryItemSnapshots", "id");
    }


    // verify required parameter 'pageIndex' is not null or undefined
    if (pageIndex === null || pageIndex === undefined) {
      throw new RequiredError("ListInventoryItemSnapshotsApi", "listInventoryItemSnapshots", "pageIndex");
    }


    // verify required parameter 'pageSize' is not null or undefined
    if (pageSize === null || pageSize === undefined) {
      throw new RequiredError("ListInventoryItemSnapshotsApi", "listInventoryItemSnapshots", "pageSize");
    }


    // verify required parameter 'snapshotType' is not null or undefined
    if (snapshotType === null || snapshotType === undefined) {
      throw new RequiredError("ListInventoryItemSnapshotsApi", "listInventoryItemSnapshots", "snapshotType");
    }


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("ListInventoryItemSnapshotsApi", "listInventoryItemSnapshots", "projectId");
    }




    // Path Params
    const localVarPath = '/projects/{projectId}/inventory/{id}/snapshots'
      .replace('{' + 'id' + '}', encodeURIComponent(String(id)))
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.GET, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")

    // Query Params
    if (start !== undefined) {
      requestContext.setQueryParam("start", ObjectSerializer.serialize(start, "Date", "date-time"));
    }

    // Query Params
    if (end !== undefined) {
      requestContext.setQueryParam("end", ObjectSerializer.serialize(end, "Date", "date-time"));
    }

    // Query Params
    if (pageIndex !== undefined) {
      requestContext.setQueryParam("pageIndex", ObjectSerializer.serialize(pageIndex, "number", ""));
    }

    // Query Params
    if (pageSize !== undefined) {
      requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
    }

    // Query Params
    if (snapshotType !== undefined) {
      requestContext.setQueryParam("snapshot_type", ObjectSerializer.serialize(snapshotType, "string", "tobedefined"));
    }


    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class ListInventoryItemSnapshotsApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to listInventoryItemSnapshots
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async listInventoryItemSnapshotsWithHttpInfo(response: ResponseContext): Promise<HttpInfo<ListInventoryItemSnapshotsResponse >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: ListInventoryItemSnapshotsResponse = ObjectSerializer.deserialize(
        await response.body.json(),
        "ListInventoryItemSnapshotsResponse", ""
      ) as ListInventoryItemSnapshotsResponse;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("404", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Inventory item not found", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: ListInventoryItemSnapshotsResponse = await response.body.json() as ListInventoryItemSnapshotsResponse;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
